import * as React from "react";

import {cs} from "@Common/react/chain-services";

import {ImageFieldCreator} from "./imageFieldCreator";
import {CustomizationTile} from "./customizationTile";


export const Headshots = ({orderId, headshotData, domRef, updateImage, onApplyImageFromPhotoDashboard, showGallery, imageGuidelinesModal, allowedGalleryTabs, editable, setUnsavedChanges}) => cs(
    ({}) =>
        <CustomizationTile
            domRef={domRef}
            header="Headshots"
            imageGuidelinesModal={imageGuidelinesModal}
            xdQaName="Headshots"
        >
            <ImageFieldCreator
                orderId={orderId}
                data={headshotData}
                imageType={"headshot"}
                updateImage={updateImage}
                showGallery={showGallery}
                onApplyImageFromPhotoDashboard={onApplyImageFromPhotoDashboard}
                editable={editable}
                allowedGalleryTabs={allowedGalleryTabs}
                setUnsavedChanges={setUnsavedChanges}
                xdQaName={"Headshot"}
            />
        </CustomizationTile>
);